var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAvatar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#B0B0B0;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1306.000000, -24.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1318,26c-5.5,0-10,4.5-10,10s4.5,10,10,10s10-4.5,10-10S1323.5,26,1318,26z M1318,30.6 c1.8,0,3.3,1.5,3.3,3.4s-1.5,3.4-3.3,3.4s-3.3-1.5-3.3-3.4S1316.2,30.6,1318,30.6z M1318,44.9c-2.3,0-4.5-0.9-6.2-2.5 c1.7-2.3,3.9-3.5,6.2-3.5s4.5,1.2,6.2,3.5C1322.5,44,1320.3,44.9,1318,44.9z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatar);
export default __webpack_public_path__ + "static/media/avatar.193bfc4d311ce43fea7270989ca67e8c.svg";
export { ForwardRef as ReactComponent };